<div class="w-100 view-item text-center">
    <p>Evolution des ventes en fonction du jour de la semaine</p>
</div>
<div class="statview chart-wrapper">
    <canvas id="statchart" baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
        [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
    </canvas>
</div>
